import { RequestLog } from '@engine/models'

interface DocumentLookupStatusBadgeProps {
  log: RequestLog
}

const statusBadgeClass: Record<string, string> = {
  ok: 'badge-success',
  'not-found': 'badge-neutral',
  error: 'badge-error',
}

const DocumentLookupStatusBadge = ({ log }: DocumentLookupStatusBadgeProps) => {
  const responseContent = log.tenantResponse?.content as {
    status?: string
    errorType?: string
    errors?: Array<{ type?: string }>
  }

  if (!responseContent?.status) {
    return <span className="text-xs opacity-50">N/A</span>
  }

  const status = responseContent.status.toLowerCase()
  const badgeClass = statusBadgeClass[status] ?? 'badge-neutral'

  if (status === 'error') {
    const errorType =
      responseContent.errorType || responseContent.errors?.[0]?.type

    return (
      <span className={`badge badge-sm ${badgeClass}`}>
        {errorType || 'error'}
      </span>
    )
  }

  return <span className={`badge badge-sm ${badgeClass}`}>{status}</span>
}

export { DocumentLookupStatusBadge }
